import { clearAuth, clearUserInfo, setAuth, setUserInfo } from '@/auth'
import { resetRouter } from '@tellus/router'
import { httpApi } from './api'
import { useHttp } from './index'

export function loginRequest(params) {
  return new Promise((resolve, reject) => {
    const http = useHttp()
    http
      .request(
        httpApi.Login,
        {
          UserId: params.userId,
          Password: params.password
        },
        { errCallback: () => reject() }
      )
      .then(result => {
        setAuth(result)
        resolve(result)
      })
      .catch(err => {
        clear()
        reject(err)
      })
  })
}

export function userInfoRequest(params) {
  return new Promise((resolve, reject) => {
    const http = useHttp()
    http
      .request(httpApi.UserInfo, params)
      .then(result => {
        setUserInfo(result)
        resolve(result)
      })
      .catch(err => {
        clear()
        reject(err)
      })
  })
}

export function logoutRequest(params) {
  return new Promise((resolve, reject) => {
    const http = useHttp()
    http
      .request(httpApi.Logout, params)
      .then(result => {
        clear()
        resolve(result)
      })
      .catch(err => {
        clear()
        reject(err)
      })
  })
}

export function routerNavRequest(params) {
  return new Promise((resolve, reject) => {
    const http = useHttp()
    http
      .request(httpApi.RouterNav, params)
      .then(result => {
        resolve(result)
      })
      .catch(err => {
        clear()
        reject(err)
      })
  })
}

function clear() {
  clearUserInfo()
  clearAuth()
  resetRouter()
}
